export default __webpack_public_path__ + "static/support_teachers-8f105febda8ee3925f024780cdbb2991.mp4";